import { PapRequestStatus } from '@app/pcs/models/pap-request-status';
import { PapRequestStatusType } from '@app/pcs/models/pap-request-status-type';
import * as R from 'ramda';

export interface PapRequestStatusPossibility {
  papRequestStatus: PapRequestStatus;
  group?: number;
  supportsChange?: boolean;
  nextPossibleStatuses?: PapRequestStatusType[];
}

type SupportsChange = (s: PapRequestStatusPossibility) => boolean;
export const supportsChange: SupportsChange = R.prop('supportsChange');

type GetPapRequestStatus = (s: PapRequestStatusPossibility) => PapRequestStatus;
export const getPapRequestStatus: GetPapRequestStatus = R.prop('papRequestStatus');
